import { CoverDetails, Quote } from "@/stores/risk/types/types";
import dayjs from "dayjs";
import { isRepeaterItemEmpty } from "@mbs-npm/anpost-ui";

export function appendDecimal(input: string | undefined | null) {
    if (input && input.indexOf(".") > -1) {
        const parts = input.split(".");
        const decimalsNeeded = 2 - parts[1].length;
        for (var i = 0; i < decimalsNeeded; i++) {
            input += "0";
        }
    }

    return input;
}

export function buildId(props, id: string) {
    if (props.index !== null) {
        return `${props.type}-${props.index}-${id}`;
    }
    return `${props.type}-${id}`;
}

export function formatDate(date: string | null | undefined) {
    if (typeof date === "string") {
        return dayjs(date).format("DD/MM/YYYY");
    }
    return date;
}

export function getFormattedLogoName(insurer: string) {
    const parts = insurer.split("-");
    const formattedName = (parts.length > 1 ? parts[1] : parts[0]).trim().toLowerCase();
    return formattedName;
}

export function removeSpacesAndParentheses(input: string) {
    const output = input.replace(/\s+/g, "").replace("(", "").replace(")", "");
    return output;
}

export function formatDateAndTime(str: string | null, amPm: boolean = false) {
    if (typeof str === "string") {
        return dayjs(str, "YYYY-MM-DD HH:mm:ss", true).format(`DD/MM/YYYY HH:mm${amPm ? "a" : ""}`);
    }
    return str;
}

export function scrollToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}

export function isInsurer(quote: Quote, insurerName: string) {
    return (quote.insurer_name?.toLowerCase().indexOf(insurerName.toLowerCase()) ?? -1) > -1;
}

export function capitalizeName(name: string) {
    if (!name) return name; // Handle empty strings

    // Capitalize the first letter and any letter after a space, apostrophe or hyphen
    return name.replace(/(^.|[\s'-].)/g, match => match.toUpperCase());
}

export function sanitizeCoverDetails(coverDetails: CoverDetails) {
    if (!coverDetails?.has_specified_items || !Array.isArray(coverDetails.specified_items)) {
        coverDetails.specified_items = [];
        return coverDetails;
    }

    const filteredItems = coverDetails.specified_items.filter(
        (item: any) => !isRepeaterItemEmpty(item)
    );

    return {
        ...coverDetails,
        specified_items: filteredItems,
        has_specified_items: filteredItems.length > 0,
    };
}
